import {Controller} from "@hotwired/stimulus";
import $ from "jquery";

export default class extends Controller {
    static targets = [ "filters" ];

    connect() {
        console.log('hello search form');
        const that = $(this.element);
        setTimeout((() => this.submitSearch(that)), 10);
    }

    submitSearch(elem) {
        console.log('submit after load');
        if (document.getElementById('initial-load')) {
            console.log('retry course load');
            $('.submit-btn').click();
            setTimeout((() => this.submitSearch(elem)), 250);
        } else {
            console.log('courses are loaded');
        }
    }

    toggleFilters(e) {
        e.preventDefault()
        let toggle = $(e.target);
        toggle.toggleClass('active');
        $(this.filtersTarget).toggle();
    }

    removeFilter(event) {
        // this.element is the form
        let search = $(this.element);
        console.log('remove', event.params);
        let filters = event.params.filter;
        if (filters === 'date_range') {
            search.find('#to, #from').val('');
        } else {
            let box = search.find(filters);
            box.prop('checked', false);
            // update switch
            let pane = box.closest('.switch-pane');
            let boxes = pane.find('input[type="checkbox');
            let selected = boxes.toArray().some(b => b.checked)
            if (!selected) {
                // mark the toggle before the pane
                pane.prev().addClass('empty');
            }
        }

        search.find('.submit-btn').trigger('click');
    }
}